import script from "./HelpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1135bfa9"]])

export default __exports__